<template>
<!-- :expanded.sync="expanded"
    :single-expand="singleExpand" :show-expand="false" -->
<v-data-table no-data-text="اطلاعاتی موجود نیست" :item-class="itemRowColor" :headers="headers" :items="data" disable-pagination :hide-default-footer="true" fixed-header item-key="_id">
  <!-- <template v-slot:[`item.balance`]="{ item }"> -->
  <!-- <template v-if="item.balance"> -->
  <!-- not change to | currencyDisplay  -->
  <!-- <span>{{ item.balance.toLocaleString() }}</span> -->
  <!-- </template> -->
  <!-- </template> -->
  <template v-slot:[`item.sum_value`]="{ item }">
    <template v-if="item.sum_value">
      <span>{{ item.sum_value | valueDisplay }}</span>
    </template>
  </template>
  <template v-slot:[`item.sum_value2`]="{ item }">
    <template v-if="item.sum_value2">
      <span>{{ item.sum_value2 | valueDisplay }}</span>
    </template>
  </template>
  <template v-slot:[`item.avg_price`]="{ item }">
    <template v-if="item.avg_price">
      <span>{{ item.avg_price.toLocaleString() }}</span>
    </template>
  </template>
  <template v-slot:[`item.price`]="{ item }">
    <template v-if="item.price">
      <span>{{ item.price.toLocaleString() }}</span>
    </template>
  </template>
  <template v-slot:[`item.price1`]="{ item }">
    <template v-if="item.price1">
      <span>{{ item.price1 | currencyDisplay }}</span>
    </template>
  </template>
  <template v-slot:[`item.price2`]="{ item }">
    <template v-if="item.price2">
      <span>{{ item.price2 | currencyDisplay }}</span>
    </template>
  </template>
  <template v-slot:[`item.total`]="{ item }">
    <template v-if="item.total">
      <span>{{ Math.abs(item.total) | currencyDisplay }}</span>
    </template>
  </template>
  <template v-slot:[`item.lending`]="{ item }">
    <v-simple-checkbox v-model="item.lending" disabled></v-simple-checkbox>
  </template>
  <template v-slot:[`item.actions`]="{ item }">
    <MyListActionKeys :item="item"/>
  </template>
  <!-- <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="3">
        _id ==> {{ item._id }}
      </td>
      <td :colspan="3">
        _id ==> {{ item._id }}
      </td>
    </template> -->
</v-data-table>
</template>

<script>
// import TutorialDataService from "../services/TutorialDataService";
import MyListActionKeys from '../../components/list/ListActionKeys.vue'
export default {
  name: "table-list",
  data() {
    return {};
  },
  methods: {
    itemRowColor: function(item) {
      // console.log(item);
      if (item.type) {
        //buy, rec
        if (['خرید', 'دریافت', 'دریافت کالا'].includes(item.type)) {
          return 'style-2'
        } else { //sale, pay
          return 'style-1'
        }
        // if (item.type === 'خرید' || item.type === 'دریافت' ||) {
        //   return 'style-2'
        // } else { //sale, pay
        //   return 'style-1'
        // }
      }
      // if (item.type)
      //   return item.type !== 'دریافت' ? 'style-1' : 'style-2'
    },
    sumField(key) {
      // sum data in give key (property)
      return this.data.reduce((a, b) => a + (b[key] || 0), 0)
    },
  },
  props: ['loading', 'headers', 'data'],
  components: {
    MyListActionKeys,
  }
};
</script>

<style lang="scss">
table,
td {
    // border: 2px solid lightgray;
    // border-collapse: separate;
    font-size: 20px !important;
    // color: blue;
}
th {
    // border: 3px solid lightgray;
    // border-collapse: inherit;
    font-size: 20px !important;
    background-color: #546E7A !important;
    color: whitesmoke !important;
    // text-align: center;
}
table tr:nth-child(odd) {
    background-color: #fff;
}
table tr:nth-child(even) {
    background-color: #eee;
}
</style>
